import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'
import { Box, Text, TextLink } from '@machobear/design-system'
import { useDispatch } from 'react-redux'

import ENV_VARS from '@/config'
import { colors } from '@/styles'
import useRole from '@/hooks/use-role'
import { WarningIconTriangle } from '@/components/icons'
import { showWarningModalWithCloseButton } from '@/components/warning-modal'

const { DASHBOARD_URL } = ENV_VARS

const BottomContainer = styled.div`
  margin-top: 32px;
  padding: 0 15px;
  width: 100%;
`

const PostListingButton = styled.button`
  font-family: var(--font-open-sans, 'Open Sans', sans-serif);
  background-color: #132b3e;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: ${colors.white};
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.2px;
  line-height: 16px;
  margin: 0 0 16px;
  padding: 15px 10px;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
`

const LoginButton = styled.button`
  font-family: var(--font-open-sans, 'Open Sans', sans-serif);
  background-color: ${colors.white};
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border: 1.5px solid ${colors.grey88};
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.2px;
  line-height: 16px;
  margin: 0;
  padding: 15px 10px;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
`

const SidebarBottomContainerMobile = ({ loginClick, signupClick }) => {
  const { t } = useTranslation()
  const router = useRouter()
  const dispatch = useDispatch()
  const logout = () => dispatch.auth.logout()
  const role = useRole()
  const isLandlord = role === 'landlord'
  const isTenant = role === 'tenant'
  const handleClickPostAListing = e => {
    e.stopPropagation()
    if (isTenant) {
      showWarningModalWithCloseButton({
        title: t(
          'r.landlord.view.logged_in_as_renter.title',
          "Oops! It looks like you're logged in as a renter."
        ),
        message: t(
          'r.landlord.view.logged_in_as_renter.text',
          'To access landlord-specific features, please log out and sign up for a landlord account or log in with your landlord account details.'
        ),
        icon: WarningIconTriangle,
        iconBgColor: '#FCF5D7',
        button: {
          text: t('common.log_out', 'Log Out'),
          onClick: logout
        }
      })
    } else {
      isLandlord
        ? (window.location.href = `${DASHBOARD_URL}/listing/create`)
        : router.push({
            pathname: '/post-a-listing',
            query: { accountType: 'essentials' }
          })
    }
  }
  return (
    <BottomContainer>
      <PostListingButton
        onClick={handleClickPostAListing}
        id="menu-account-login"
      >
        {t('Post a Listing')}
      </PostListingButton>
      <LoginButton onClick={loginClick} id="menu-account-login">
        {t('common.login', 'Log in')}
      </LoginButton>
      <Box
        display="flex"
        width="full"
        justifyContent="center"
        alignItems="center"
        gap="xxsmall"
        marginTop="large"
      >
        <Text weight="medium">
          {t('No Account?')}{' '}
          <TextLink
            style={{ textDecoration: 'underline' }}
            onClick={signupClick}
          >
            {t('Click to Sign up')}
          </TextLink>
        </Text>
      </Box>
    </BottomContainer>
  )
}

export default SidebarBottomContainerMobile
